import { connect } from 'react-redux';
import FavoriteStationIcon from './FavoriteStationIcon';
import {
  addStationToFavorites,
  deleteStationFromFavorites,
  getFavoriteLists,
} from '../../actions/favorites';

let dispatchedStationId;
let fetchedFavoriteLists;

function mapStateToProps({ favorites, auth, config }, { stationId }) {
  return {
    isSaving: dispatchedStationId === stationId && favorites.isSaving,
    isDeleting: dispatchedStationId === stationId && favorites.isDeleting,
    isFetching: favorites.isFetching,
    favoriteLists: favorites.favoriteLists,
    error: favorites.error,
    isLoggedIn: !!auth.account_id,
    identityHost: config.identityHost,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addStationToFavorites: (listId, stationId) => {
      dispatchedStationId = stationId;
      dispatch(addStationToFavorites(listId, Number(stationId)));
    },
    deleteStationFromFavorites: (listId, stationId) => {
      dispatchedStationId = stationId;
      dispatch(deleteStationFromFavorites(listId, Number(stationId)));
    },
    fetchFavoriteLists: () => {
      if (!fetchedFavoriteLists) {
        fetchedFavoriteLists = true;
        return dispatch(getFavoriteLists());
      }

      return null;
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteStationIcon);
